import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import MaterialDialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Type from '../typography';

const noop = () => {};

const Dialog = forwardRef(
    ({ icon, title, actions, children, ...props }, ref) => (
        <MaterialDialog
            aria-labelledby="NeptuneDialogTitle-title"
            {...props}
            ref={ref}
        >
            <MuiDialogTitle disableTypography>
                <div className="NeptuneDialogTitle-title">
                    {icon}
                    <Type component="h2" variant="h2">
                        {title}
                    </Type>
                </div>
                {props.onClose !== noop && (
                    <IconButton
                        aria-label="close"
                        onClick={props.onClose}
                        className="NeptuneDialogTitle-close"
                    >
                        <CloseIcon />
                    </IconButton>
                )}
            </MuiDialogTitle>
            <MuiDialogContent>{children}</MuiDialogContent>
            <MuiDialogActions>{actions}</MuiDialogActions>
        </MaterialDialog>
    )
);

Dialog.displayName = 'NeptuneDialog';

Dialog.propTypes = {
    ...MaterialDialog.propTypes,
    onClose: PropTypes.func
};

Dialog.defaultProps = {
    ...MaterialDialog.defaultProps,
    onClose: noop
};

export default Dialog;
